import { render, staticRenderFns } from "./CheckIcon.vue?vue&type=template&id=2d6732d9"
import script from "./CheckIcon.vue?vue&type=script&lang=js"
export * from "./CheckIcon.vue?vue&type=script&lang=js"
import style0 from "./CheckIcon.vue?vue&type=style&index=0&id=2d6732d9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports